import yup from 'utils/yup';

export const initialTimeClockFormData = {
  job_id: '' as any,
  task_id: '' as any,
  notes: '',
};

export const timeClockFormValidationSchema = {
  job_id: yup.string(),
  task_id: yup.string(),
  mileage: yup.number(),
  notes: yup.string(),
};

export const initialFormValue = {
  jobName: '',
  taskName: '',
  mileage: 0,
  notes: '',
};

export const breakFormValidationSchema = {
  start: yup.string(),
  end: yup.string(),
  break_duration: yup.number().notRequired(),
};
